module.exports = __webpack_public_path__ + "8a296a2b165e122c1897a22b8f9bdd1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/GameDay/res/GMD_dev_staging_logo.png
// module id = 1127
// module chunks = 0